// extracted by mini-css-extract-plugin
export default {"card":"card_card__Qx6ZK","yellowBtn":"card_yellowBtn__G6YVU"};